export function isNumeric(v: unknown): boolean {
  return (v as number) - parseFloat(v as string) >= 0;
}
